import { IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import React, { useState } from "react";
import { withRouter } from "react-router";
import { Button } from "@material-ui/core";

import { PuntoServicio, ReclamosFiltrosProps } from "src/utils/interfaces";
import { opcionAPuntoServicio } from "src/utils/especificos";
import { adjuntarComoQueryParam as adjuntar } from "src/utils/comunicacionAPI";

import Header from "src/components/Header";
import Autocomplete from "src/components/Autocomplete";
import DatePicker from "src/components/DatePicker";
import { dateAFormatoGlobal } from "src/utils/fechas";

const ReclamosFiltros: React.FC<ReclamosFiltrosProps> = (
  props: ReclamosFiltrosProps
) => {
  const [puntoDeServicio, setPuntoDeServicio] = useState<
    PuntoServicio | undefined
  >(props.filtros.puntoDeServicio);
  const [fechaInicio, setFechaInicio] = useState<Date | undefined>(
    props.filtros.fechaInicio
  );
  const [fechaFin, setFechaFin] = useState<Date | undefined>(
    props.filtros.fechaFin
  );

  const handleClickFiltrar = () => {
    const filtros = {
      puntoDeServicio: puntoDeServicio,
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
    };

    const inicio = fechaInicio ? dateAFormatoGlobal(fechaInicio) : undefined;
    const fin = fechaFin ? dateAFormatoGlobal(fechaFin) : undefined;

    let params = "";
    params = adjuntar(params, "nombre_ps", puntoDeServicio?.nombre);
    params = adjuntar(params, "codigo_ps", puntoDeServicio?.codigo);
    params = adjuntar(params, "fecha_desde", inicio);
    params = adjuntar(params, "fecha_hasta", fin);

    props.handleFiltrosChange(filtros);
    props.history.push(`/reclamos${params}`);
  };

  const limpiarFiltros = () => {
    setPuntoDeServicio(undefined);
    setFechaInicio(undefined);
    setFechaFin(undefined);

    props.handleFiltrosChange({
      puntoDeServicio: undefined,
      fechaInicio: undefined,
      fechaFin: undefined,
    });

    props.history.push("/reclamos");
  };

  const opcion = puntoDeServicio
    ? {
        id: puntoDeServicio.codigo,
        nombre: puntoDeServicio.nombre,
      }
    : null;

  const botonCerrar = {
    icono: closeOutline,
    action: () => props.history.goBack(),
  };

  const botonesDerecha = {
    src: "assets/icon/clear-filter.svg",
    action: limpiarFiltros,
  };

  return (
    <IonPage>
      <Header
        titulo="Filtrar Reclamos"
        botonIzq={botonCerrar}
        botonesDerecha={[botonesDerecha]}
      />

      <IonContent>
        <div className="container">
          <form
            id="filter-form"
            className="d-flex flex-column align-items-center"
          >
            <Autocomplete
              label="Punto de Servicio"
              className="mt-3"
              value={opcion}
              setValue={(opcion) =>
                setPuntoDeServicio(opcionAPuntoServicio(opcion))
              }
            />

            <IonGrid className="two-columns">
              <IonRow>
                <IonCol>
                  <DatePicker
                    className="half"
                    value={fechaInicio}
                    setValue={setFechaInicio}
                    placeholder="Fecha inicial"
                  />
                </IonCol>

                <IonCol>
                  <DatePicker
                    className="half"
                    value={fechaFin}
                    setValue={setFechaFin}
                    placeholder="Fecha final"
                  />
                </IonCol>
              </IonRow>
            </IonGrid>

            <Button
              className="button"
              variant="contained"
              color="primary"
              onClick={handleClickFiltrar}
            >
              FILTRAR
            </Button>
          </form>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(ReclamosFiltros);
